import React, {useEffect, useRef} from "react";
import style from './terms.module.css';
import {useLocation} from "react-router-dom";

const Terms = () => {
  const timerFadeIn = useRef(null);
  const termsRef = useRef(null);
  const location = useLocation();
  const fileName = location.state;
  // console.log(fileName);


  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (termsRef.current) {
      termsRef.current.classList.add(style.termsFadeIn);
    }

    timerFadeIn.current = setTimeout(() => {
      termsRef.current.classList.remove(style.termsFadeIn);
    }, 350);

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  return (
    <div ref={termsRef}
         className={style.container}>
      <div className={style.iframeWrapper}>
        <iframe className={style.iframe} src={`https://sk.servicelands.com/edc/avocado/${fileName}-sk.html`}
        ></iframe>
      </div>
    </div>
  )
}

export default Terms;